import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useCallback } from 'react';

const useOperationQueries = () => {
  const { enqueueSnackbar } = useSnackbar();

  const request = useCallback(
    (promise, { successMessage } = {}) =>
      promise
        .then(res => {
          if (res.status === 200) {
            if (successMessage) {
              enqueueSnackbar(successMessage, { variant: 'success' });
            }
            return !!res.data.value ? res.data?.value : res.data;
          }
          enqueueSnackbar(res?.message, { variant: 'error' });
          return null;
        })
        .catch(err => {
          enqueueSnackbar(err?.message || err?.response?.data?.message, {
            variant: 'error',
          });
          return null;
        }),
    [enqueueSnackbar],
  );

  const getAvailableAgents = useCallback(
    zoneGuid =>
      request(
        axiosClient.get('InventoryAgent/GetAllAgentAvailable', {
          params: { Guid: zoneGuid },
        }),
      ),
    [request],
  );

  return {
    getAvailableAgents,
  };
};

export default useOperationQueries;
